import { fetcher } from '@chipinside/fetcher'
import { useEffect } from 'react'
import { clarity } from 'react-microsoft-clarity'

import { usePage } from '#/components/HelpPages/utils'
import { useCompanySlug } from '#/store/ducks/company'
import { useFarmSlug } from '#/store/ducks/farm'
import useAppContext from '#/store/hooks/useAppContext'
import { endpoint } from '#/store/services/endpoints'
import { hitAnalytics } from '#/store/services/Firebase/Analytics'
import { ResolvedPage } from '#/store/services/Pages/PagesService'
import { Sentry } from '#/store/services/Sentry'

export default function useCxTracking() {
  const farmSlug = useFarmSlug()
  const companySlug = useCompanySlug()
  const context = useAppContext()
  const page = usePage()
  const slug = getSlugByContext({ companySlug, context, farmSlug })

  useEffect(() => {
    if (page) {
      Sentry.hitPage({ page })
      if (context === 'farm') {
        hitCx({ context, page, slug })
        hitClarity(page)
        hitAnalytics({ farmSlug, page })
      }
    }
  }, [page?.id, farmSlug])
}

function hitClarity({ id }: ResolvedPage) {
  if (clarity.hasStarted()) {
    clarity.setTag('page', id)
  }
}

type HitCxParams = {
  page: ResolvedPage
  slug?: string
  context: 'farm' | 'company' | 'system'
}

function hitCx({ context, page, slug }: HitCxParams) {
  if (!slug) return

  const controller = endpoint.tracking()

  const params = {
    /**
     * context refere-se ao contexto da página, no caso 'farm', 'company', etc
     * atualmente aceita apenas 'farm' | 'company' na parte do backend
     */
    context,
    identifier: page.id,
    platform: 'web',
    /**
     * slug do "item" do contexto, no caso a fazenda ou company
     */
    slug,
  }

  fetcher({ controller, method: 'post', params }).catch(error => console.info(error))
}

type GetSlugByContextParams = {
  context: 'farm' | 'company' | 'system'
  farmSlug?: string
  companySlug?: string
}

function getSlugByContext({ companySlug, context, farmSlug }: GetSlugByContextParams) {
  switch (context) {
    case 'farm':
      if (!farmSlug) return
      return farmSlug

    case 'company':
      if (!companySlug) return
      return companySlug

    default:
      break
  }
}
